const Cloudplay:any = (<any>window).Cloudplay;

export default Cloudplay;